import { Icon } from "../components/Icon";
import { RichText, useSiteTranslation } from "../i18n";
import logo from "../../../pictures/home/logo-m.png";
import floral from "../../../pictures/home/floral.png";
import "../styles/promise.css";

// Widths of the decorative barcode bars, in px.
const BARCODE = [3, 1, 2, 1, 4, 1, 1, 3, 2, 1, 3, 1, 2, 4, 1, 2, 1, 3, 1, 1, 4, 2, 1, 3, 1, 2, 1, 4, 1, 3, 2, 1];

function Receipt() {
  const { t } = useSiteTranslation();
  const items = t("home.promise.items", { returnObjects: true });

  return (
    // The reveal animation sets its own transform, so the tilt lives on the inner element.
    <div className="receipt-wrap" data-reveal style={{ "--delay": ".12s" }}>
      <div className="receipt-tilt">
        <div className="receipt">
          <div className="receipt-head">
            <img src={logo} alt="" />
            <span>MJMarry</span>
            <small>{t("home.promise.receipt")}</small>
          </div>
          <ul className="receipt-lines">
            {items.map((item) => (
              <li className="receipt-line" key={item}>
                <span>{item}</span>
                <i aria-hidden="true" />
                <b>{t("common.free")}</b>
              </li>
            ))}
          </ul>
          <div className="receipt-total">
            <span>{t("home.promise.total")}</span>
            <strong dir="ltr">$0.00</strong>
          </div>
          <p className="receipt-note">{t("home.promise.note")}</p>
          <div className="receipt-barcode" aria-hidden="true">
            {BARCODE.map((width, index) => (
              <span key={index} style={{ width }} />
            ))}
          </div>
        </div>
        <span className="receipt-stamp" aria-hidden="true">
          {t("common.free")}
        </span>
      </div>
    </div>
  );
}

export function FreePromiseSection() {
  const { t } = useSiteTranslation();
  const perks = t("home.promise.perks", { returnObjects: true });

  return (
    <section className="free-promise">
      <img className="free-floral" src={floral} alt="" aria-hidden="true" />
      <div className="wrap free-grid">
        <div className="free-copy" data-reveal>
          <p className="eyebrow light">{t("home.promise.eyebrow")}</p>
          <h2>
            <RichText k="home.promise.title" />
          </h2>
          <p className="free-text">{t("home.promise.text")}</p>
          <ul className="free-perks">
            {perks.map((perk) => (
              <li key={perk}>
                <Icon name="check" />
                {perk}
              </li>
            ))}
          </ul>
        </div>
        <Receipt />
      </div>
    </section>
  );
}
